import React from 'react';
import '../assets/styles/About.scss';

const About = () => {
  return (
    <div className="about-container" id="about">
      <h1>About</h1>
      <p>
        I'm a Robotics Engineer passionate about building intelligent, human-centered systems. I specialize in ROS, perception, and control systems, with hands-on experience developing full-stack robotic solutions — from simulation to real-world deployment. Whether it’s crafting autonomous navigation algorithms or designing low-cost robotic prototypes, I love bridging theory and application.
      </p>
    </div>
  );
};

export default About;
